const money = (cents) => new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(cents / 100);
const GIFT_VARIANT = 67874030518360;
const drawer = document.querySelector("[data-drawer]");
const body = document.querySelector("[data-cart-body]");
const countEl = document.querySelector("[data-cart-count]");

async function syncGift(cart) {
  const gift = cart.items.find((item) => item.variant_id === GIFT_VARIANT);
  const merch = cart.items.filter((item) => item.variant_id !== GIFT_VARIANT).reduce((sum, item) => sum + item.final_line_price, 0);
  if (merch >= 6000 && (!gift || gift.quantity !== 1)) {
    if (!gift) {
      await fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ id: GIFT_VARIANT, quantity: 1 }) });
    } else {
      await fetch("/cart/change.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ id: gift.key, quantity: 1 }) });
    }
    return fetch("/cart.js").then((r) => r.json());
  }
  if (merch < 6000 && gift) {
    await fetch("/cart/change.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ id: gift.key, quantity: 0 }) });
    return fetch("/cart.js").then((r) => r.json());
  }
  return cart;
}

async function renderCart() {
  let cart = await fetch("/cart.js").then((r) => r.json());
  cart = await syncGift(cart);
  if (countEl) countEl.textContent = String(cart.item_count);
  if (!body) return;
  const merch = cart.items.filter((item) => item.variant_id !== GIFT_VARIANT).reduce((sum, item) => sum + item.final_line_price, 0);
  const note = merch >= 6000 ? "A 20 g tube of 0.05% tretinoin is included." : "Orders of $60 or more include a 20 g tube of 0.05% tretinoin.";
  if (!cart.items.length) {
    body.innerHTML = '<div class="drawer__foot"><p>Nothing in the cart yet.</p><a class="btn" href="/collections/research-compounds">Shop</a></div>';
    return;
  }
  body.innerHTML =
    '<div class="drawer__items">' +
    cart.items.map((item) => '<div class="drawer__line"><a href="' + item.url + '">' + item.product_title + (item.variant_title && item.variant_title !== "Default Title" ? " · " + item.variant_title : "") + "</a><span>" + item.quantity + " · " + money(item.final_line_price) + "</span></div>").join("") +
    '</div><div class="drawer__foot"><p>' + note + " Code FALL is 15% off at checkout. Standard shipping only.</p><p class=\"price\">" +
    money(cart.total_price) +
    '</p><a class="btn" href="/checkout">Checkout</a></div>';
}

document.addEventListener("click", (event) => {
  if (event.target.closest("[data-cart-open]")) {
    drawer.hidden = false;
    renderCart();
  }
  if (event.target.closest("[data-cart-close]")) drawer.hidden = true;
  const menu = document.querySelector("[data-menu]");
  if (event.target.closest("[data-menu-open]") && menu) menu.hidden = !menu.hidden;
  if (event.target.closest("[data-chat-open]")) document.querySelector("[data-chat]").hidden = false;
  if (event.target.closest("[data-chat-close]")) document.querySelector("[data-chat]").hidden = true;
  const certificate = event.target.closest("[data-coa-open]");
  if (certificate) {
    const modal = document.querySelector("[data-coa]");
    modal.hidden = false;
    modal.querySelector("[data-coa-title]").textContent = certificate.getAttribute("data-name");
    modal.querySelector("[data-coa-name]").textContent = certificate.getAttribute("data-name");
  }
  if (event.target.closest("[data-coa-close]")) document.querySelector("[data-coa]").hidden = true;
});

document.addEventListener("submit", async (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !form.action.includes("/cart/add")) return;
  event.preventDefault();
  await fetch("/cart/add.js", { method: "POST", body: new FormData(form), headers: { Accept: "application/json" } });
  drawer.hidden = false;
  renderCart();
});

const gate = document.getElementById("nc-gate");
const gateForm = document.getElementById("nc-gate-form");
const FIVE_DAYS = 5 * 24 * 60 * 60 * 1000;
function gateOpen() {
  try {
    if (Number(localStorage.getItem("neurochem-entry") || 0) > Date.now()) return true;
    return sessionStorage.getItem("neurochem-entry-session") === "1";
  } catch (error) {
    return false;
  }
}
if (gate && !gateOpen()) {
  gate.hidden = false;
  document.body.style.overflow = "hidden";
  const boxes = [...gateForm.querySelectorAll("[data-gate]")];
  const enter = gateForm.querySelector(".gate__enter");
  const paint = () => {
    const ready = boxes.every((box) => box.checked);
    enter.disabled = !ready;
    enter.classList.toggle("is-ready", ready);
  };
  boxes.forEach((box) => box.addEventListener("change", paint));
  gateForm.addEventListener("submit", (event) => {
    event.preventDefault();
    if (enter.disabled) return;
    sessionStorage.setItem("neurochem-entry-session", "1");
    if (boxes[2].checked) localStorage.setItem("neurochem-entry", String(Date.now() + FIVE_DAYS));
    gate.hidden = true;
    document.body.style.overflow = "";
  });
}

const panel = document.querySelector("[data-panel]");
if (panel) {
  const note = panel.querySelector("[data-panel-note]");
  panel.addEventListener("change", () => {
    const picked = [...panel.querySelectorAll("input:checked")];
    if (picked.length > 4) picked[picked.length - 1].checked = false;
    note.textContent = [...panel.querySelectorAll("input:checked")].length + " of 4 selected";
  });
  panel.addEventListener("submit", async (event) => {
    event.preventDefault();
    const picked = [...panel.querySelectorAll("input:checked")].slice(0, 4);
    if (picked.length !== 4) {
      note.textContent = "Select four compounds.";
      return;
    }
    await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: picked.map((box) => ({ id: Number(box.value), quantity: 1 })) }),
    });
    drawer.hidden = false;
    renderCart();
  });
}

const log = document.querySelector("[data-chat-log]");
const chatForm = document.querySelector("[data-chat-form]");
function say(text) {
  const line = document.createElement("p");
  line.textContent = text;
  log.appendChild(line);
  log.scrollTop = log.scrollHeight;
}
if (chatForm) {
  say("Research compounds can be bought as 1, 3, 5, or 10 vials. Larger packs cost less per vial. Skincare and haircare can be bought as 1, 3, or 6. Orders of $60 or more include a 20 g tube of 0.05% tretinoin. Standard shipping only. FALL is 15% off at checkout.");
  chatForm.addEventListener("submit", async (event) => {
    event.preventDefault();
    const input = chatForm.querySelector("input");
    const text = input.value.trim();
    if (!text) return;
    say(text);
    input.value = "";
    if (/\b(dose|dosage|inject|injection|cycle|protocol|human|take this|how much should)\b/i.test(text)) {
      say("This desk does not give doses, protocols, or human-use directions. Listings are for laboratory research only.");
      return;
    }
    if (/\b(ship|deliver|overnight|fall|tretinoin|gift|free)\b/i.test(text)) {
      say("Standard shipping only. No overnight. Research compounds arrive in 7–8 business days. Skincare and haircare arrive in 3–4 weeks. Enter FALL at checkout for 15% off. Orders of $60 or more include one 20 g tube of 0.05% tretinoin.");
      return;
    }
    const found = await fetch("/search/suggest.json?q=" + encodeURIComponent(text) + "&resources[type]=product&resources[limit]=3").then((r) => r.json());
    const products = found.resources?.results?.products || [];
    if (!products.length) {
      say("No listing matches that. Try the compound name.");
      return;
    }
    say(products.map((item) => item.title + " · " + item.price).join(". "));
  });
}
